export default "__VITE_ASSET__BFnIJe8t__"